module.exports = __webpack_public_path__ + "img/logo.ca1dda12.png";